<div fxLayout="column" fxLayoutAlign="start stretch" [hidden]="!ViewReady">
    <h2 class="mat-headline">Unassigned Request Editor</h2>
    <p>
        The following request (Request #{{ RequestForm?.get('RequestIssueNumber')?.value }}) has not yet been assigned to a cabinet
        member. Use the form provided below to perform the following actions for this IRIS request:
    </p>
    <ul>
        <li>Select a category (and cabinet member) to refer the request to for a response.</li>
        <li>Select a priority level for the request. This will also assign the expected due date for the response.</li>
        <li>
            Optionally, refine the request for data-keeping purposes by specifying the school and/or board member district the request
            concerns, if applicable.
        </li>
        <li>Optionally, leave additional comments for the cabinet member in the provided tab/panel in the display below.</li>
    </ul>
    <p>
        Once you have provided the required information, click on the "Assign Request" button to assign the request to the designated
        cabinet member.
    </p>
    <form [formGroup]="RequestForm" novalidate #requestfrm="ngForm">
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="15px"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                [fxFlex]="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer' ? '45' : 'auto'"
            >
                <app-form-label [required]="true">Subject:</app-form-label>
                <div>{{ RequestForm?.get('Subject')?.value }}</div>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                fxFlex="45"
            >
                <app-form-label [required]="true">Category:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="RequestCategory"
                        placeholder="Category..."
                        aria-label="Request Category Selection List"
                        #categoryInput
                    >
                        <mat-option *ngFor="let cat of AllCategories" [value]="cat">
                            <span
                                >{{ cat.CategoryDescription }}
                                <span *ngIf="cat.CabinetMember"
                                    >({{ cat?.CabinetMember?.FirstName | titleCase }}
                                    {{ cat?.CabinetMember?.LastName | titleCase }})</span
                                ></span
                            >
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="RequestForm?.get('RequestCategory')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="15px"
        >
            <div
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                fxFlex="45"
            >
                <app-form-label [required]="true">Priority:</app-form-label>
                <mat-form-field appearance="outline" fxFlex="50" floatLabel="never" fxFlex.lt-md="auto">
                    <mat-select
                        matInput
                        formControlName="Priority"
                        placeholder="Priority..."
                        aria-label="Request Priority Selection List"
                    >
                        <mat-option [value]="1">1 - Urgent</mat-option>
                        <mat-option [value]="2">2 - High</mat-option>
                        <mat-option [value]="3">3 - Routine</mat-option>
                        <mat-option [value]="4">4 - Low</mat-option>
                    </mat-select>
                    <mat-hint *ngIf="RequestForm?.get('Priority')?.value && RequestForm?.get('Priority')?.value !== 4">
                        <em>Suggested for requests needed within {{ RequestForm?.get('Priority')?.value | priorityTime }}</em>
                    </mat-hint>
                    <mat-error *ngIf="RequestForm?.get('Priority')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
                <div
                    *ngIf="
                        RequestForm?.get('LoadedPriority')?.value != null &&
                        RequestForm?.get('LoadedPriority')?.value !== RequestForm?.get('Priority')?.value
                    "
                >
                    (Original: {{ RequestForm?.get('LoadedPriority')?.value | priority }})
                </div>
            </div>
            <!-- <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="15px"
                    *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                >
                    <app-form-label>Request Type:</app-form-label>
                    <mat-form-field appearance="outline">
                        <mat-select
                            matInput
                            formControlName="RequestSource"
                            placeholder="Request source..."
                            aria-label="Request Source Selection List"
                        >
                            <mat-option [value]="null">Request source...</mat-option>
                            <mat-option [value]="0">Board</mat-option>
                            <mat-option [value]="1">Constituent</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="15px"
                    *ngIf="
                        (User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer') &&
                        RequestForm?.get('RequestSource')?.value === 1
                    "
                >
                    <app-form-label>Constituent:</app-form-label>
                    <mat-form-field appearance="outline">
                        <input
                            type="text"
                            matInput
                            formControlName="RequestSourceDescription"
                            placeholder="Enter constituent..."
                            aria-label="Request Constituent Name"
                        />
                        <mat-hint align="start">Limit 200 characters</mat-hint>
                        <mat-hint align="end">{{ RequestForm?.get('RequestSourceDescription')?.value?.length || 0 }}/200</mat-hint>
                        <mat-error *ngIf="RequestForm?.get('RequestSourceDescription')?.hasError('required')">Required.</mat-error>
                        <mat-error *ngIf="RequestForm?.get('RequestSourceDescription')?.hasError('maxLength')"
                            >Over character limit (200).</mat-error
                        >
                    </mat-form-field>
                </div> -->
            <div
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                fxFlex
            >
                <app-form-label [required]="true">Due Date:</app-form-label>
                <!-- <div>
                    <span *ngIf="RequestForm?.get('DueDate')?.value != null">{{
                        RequestForm?.get('DueDate')?.value | date: 'M/d/yyyy'
                    }}</span>
                    <span *ngIf="RequestForm?.get('DueDate')?.value == null">Not Assigned</span>
                </div> -->
                <mat-form-field appearance="outline" *ngIf="RequestForm?.get('Priority')?.value === 4">
                    <input
                        type="text"
                        formControlName="DueDate"
                        matInput
                        aria-label="Request Due Date"
                        [matDatepicker]="dueDatePicker"
                        [matDatepickerFilter]="IsValidWorkday.bind(this)"
                        placeholder="Select due date..."
                    />
                    <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dueDatePicker></mat-datepicker>
                    <mat-error *ngIf="RequestForm?.get('DueDate')?.hasError('matDatepickerFilter')">Monday to Friday only</mat-error>
                    <mat-error *ngIf="RequestForm?.get('DueDate')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
                <div *ngIf="RequestForm?.get('Priority')?.value !== 4 && RequestForm?.get('DueDate')?.value">
                    {{ RequestForm?.get('DueDate')?.value | date: 'M/d/yyyy' }}
                </div>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap="15px"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="
                    (User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer') &&
                    RequestForm?.get('Source')?.value === 0
                "
                fxFlex="45"
                fxFlex.lt-md="auto"
            >
                <app-form-label [required]="true">Board Member:</app-form-label>
                <mat-form-field appearance="outline" fxFlex="50" fxFlex.lt-md="auto">
                    <mat-select
                        matInput
                        formControlName="RequestBoardMember"
                        placeholder="Board Member..."
                        aria-label="Request Board Member Selection List"
                    >
                        <mat-option [value]="null">Board Member...</mat-option>
                        <mat-option *ngFor="let board of BoardMembers" [value]="board"
                            >{{ board.LastName | titleCase }}, {{ board.FirstName | titleCase }} - District
                            {{ board.District }}</mat-option
                        >
                    </mat-select>
                    <mat-error *ngIf="RequestForm?.get('RequestBoardMember')?.hasError('required')">Required.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="15px"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
                fxFlex="45"
                fxFlex.lt-md="auto"
            >
                <app-form-label>School:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="SchoolNumber"
                        placeholder="School..."
                        aria-label="Request School Selection List"
                    >
                        <mat-option [value]="null">All / District-Wide</mat-option>
                        <mat-option *ngFor="let sch of AllSchools" [value]="sch.SchoolNumber"
                            >{{ sch.SchoolName }} ({{ sch.SchoolNumber }})</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'"
            >
                <app-form-label>District:</app-form-label>
                <mat-form-field appearance="outline" fxFlex>
                    <mat-select
                        matInput
                        formControlName="BoardDistrict"
                        placeholder="District..."
                        aria-label="Request District Selection List"
                    >
                        <mat-option [value]="null">All / District-Wide</mat-option>
                        <mat-option *ngFor="let dist of ['1', '2', '3', '4', '5', '6', '7']" [value]="dist">{{ dist }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <section [hidden]="SmallSize" class="mat-elevation-z5">
            <mat-tab-group [(selectedIndex)]="SelectedTabIndex" [dynamicHeight]="true">
                <mat-tab>
                    <ng-template mat-tab-label>Request / Concern</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>The following text was provided by the creator of this request:</div>
                        <div class="bordered thin-padded minimum-space">
                            <em>{{ RequestForm?.get('RequestText')?.value }}</em>
                        </div>
                        <mat-checkbox *ngIf="LoadedRequestForm?.Confidential !== true" formControlName="Confidential"
                            >This request contains confidential student and/or parent information.</mat-checkbox
                        >
                        <div *ngIf="LoadedRequestForm?.Confidential === true" class="margin-top">
                            <strong
                                >Note: This request has been marked as containing confidential student and/or parent
                                information.</strong
                            >
                        </div>
                        <ng-container *ngIf="LoadedRequestForm?.RequestAttachments?.length">
                            <div *ngIf="IsiPad" class="margin-top">
                                <em
                                    >File attachment downloads may not be possible from an Apple iPhone or iPad device. To reliably
                                    download files, please log in to the IRIS system using a desktop device to retrieve file
                                    attachments.</em
                                >
                            </div>
                            <div>
                                <em>The following file attachments were attached to this request when it was created:</em>
                                <table class="mat-table fullwidth">
                                    <thead>
                                        <tr class="mat-header-row">
                                            <th class="mat-header-cell">File Name</th>
                                            <th class="mat-header-cell">File Size</th>
                                            <th class="mat-header-cell">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            class="mat-row"
                                            *ngFor="let item of LoadedRequestForm?.RequestAttachments; index as $index"
                                        >
                                            <td class="mat-cell">
                                                <div>{{ item.FileName }}</div>
                                            </td>
                                            <td class="mat-cell centered">
                                                <div>{{ item.FileSize | fileSize }}</div>
                                            </td>
                                            <td class="mat-cell">
                                                <div fxLayout="row" fxLayoutAlign="center center">
                                                    <button
                                                        type="button"
                                                        mat-raised-button
                                                        color="primary"
                                                        (click)="HandleFileAttachment(item)"
                                                    >
                                                        Download File
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </div>
                </mat-tab>
                <mat-tab *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'">
                    <ng-template mat-tab-label>Notes For Cabinet Member</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            In the space below, you may provide any optional comments you wish to
                            <span *ngIf="!RequestForm?.get('RequestCategory')?.value">the cabinet member</span
                            ><span *ngIf="RequestForm?.get('RequestCategory')?.value"
                                >{{ RequestForm?.get('RequestCategory')?.value?.CabinetMember?.FirstName | titleCase }}
                                {{ RequestForm?.get('RequestCategory')?.value?.CabinetMember?.LastName | titleCase }}</span
                            >
                            regarding this request. These comments will only be visible to this cabinet member, and not to any other
                            individual in the IRIS System.
                        </div>
                        <mat-form-field appearance="outline" floatLabel="never">
                            <textarea
                                matInput
                                matTextareaAutosize
                                [matAutosizeMinRows]="5"
                                formControlName="SourceNotes"
                                maxlength="5000"
                                placeholder="Type text here..."
                            ></textarea>
                            <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                            <mat-hint align="end">{{ RequestForm?.get('SourceNotes')?.value?.length || 0 }}/5000</mat-hint>
                            <mat-error *ngIf="RequestForm?.get('SourceNotes')?.hasError('required')">Required.</mat-error>
                            <mat-error *ngIf="RequestForm?.get('SourceNotes')?.hasError('maxLength')"
                                >Over character limit (5000).</mat-error
                            >
                        </mat-form-field>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </section>
        <mat-accordion [hidden]="!SmallSize" [multi]="true">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header> <mat-panel-title>Request / Concern</mat-panel-title> </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                    <div>The following text was provided by the creator of this request:</div>
                    <div class="bordered thin-padded minimum-space">{{ RequestForm?.get('RequestText')?.value }}</div>
                    <mat-checkbox *ngIf="LoadedRequestForm?.Confidential !== true" formControlName="Confidential"
                        >This request contains confidential student and/or parent information.</mat-checkbox
                    >
                    <div *ngIf="LoadedRequestForm?.Confidential === true" class="margin-top">
                        <strong
                            >Note: This request has been marked as containing confidential student and/or parent information.</strong
                        >
                    </div>
                    <ng-container *ngIf="LoadedRequestForm?.RequestAttachments?.length">
                        <div *ngIf="IsiPad" class="margin-top margin-bottom">
                            <em
                                >File attachment downloads may not be possible from an Apple iPhone or iPad device. To reliably
                                download files, please log in to the IRIS system using a desktop device to retrieve file
                                attachments.</em
                            >
                        </div>
                        <div [class.margin-top]="!IsiPad">
                            <em>The following file attachments were attached to this request when it was created:</em>
                            <table class="mat-table fullwidth">
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">Files</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="mat-row" *ngFor="let item of LoadedRequestForm?.RequestAttachments; index as $index">
                                        <td class="mat-cell">
                                            <div class="margin-top">{{ item.FileName }} ({{ item.FileSize | fileSize }})</div>
                                            <div fxLayout="row" fxLayoutAlign="center center" class="margin-bottom">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    color="primary"
                                                    (click)="HandleFileAttachment(item)"
                                                >
                                                    Download File
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="true" *ngIf="User?.CurrentRole === 'Facilitator' || User?.CurrentRole === 'Developer'">
                <mat-expansion-panel-header>
                    <mat-panel-title> <span>Notes For Cabinet Member</span> </mat-panel-title>
                </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                    <div>
                        In the space below, you may provide any optional comments you wish to
                        <span *ngIf="!RequestForm?.get('RequestCategory')?.value">the cabinet member</span
                        ><span *ngIf="RequestForm?.get('RequestCategory')?.value"
                            >{{ RequestForm?.get('RequestCategory')?.value?.CabinetMember?.FirstName | titleCase }}
                            {{ RequestForm?.get('RequestCategory')?.value?.CabinetMember?.LastName | titleCase }}</span
                        >
                        regarding this request. These comments will only be visible to this cabinet member, and not to any other
                        individual in the IRIS System.
                    </div>
                    <mat-form-field appearance="outline" floatLabel="never">
                        <textarea
                            matInput
                            matTextareaAutosize
                            [matAutosizeMinRows]="5"
                            formControlName="SourceNotes"
                            maxlength="5000"
                            placeholder="Type text here..."
                        ></textarea>
                        <mat-hint align="start">Limit of 5,000 characters</mat-hint>
                        <mat-hint align="end">{{ RequestForm?.get('SourceNotes')?.value?.length || 0 }}/5000</mat-hint>
                        <mat-error *ngIf="RequestForm?.get('SourceNotes')?.hasError('required')">Required.</mat-error>
                        <mat-error *ngIf="RequestForm?.get('SourceNotes')?.hasError('maxLength')"
                            >Over character limit (5000).</mat-error
                        >
                    </mat-form-field>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div
            fxLayout="row"
            fxLayoutAlign="center center"
            fxLayoutGap="15px"
            class="actionbar"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start center"
        >
            <button type="button" mat-raised-button color="warn" (click)="ResetRequestForm(true)">Reset Form</button>
            <button type="button" mat-raised-button color="primary" (click)="AssignRequest()" [disabled]="RequestForm.invalid">
                Assign Request
            </button>
            <button type="button" mat-raised-button color="warn" (click)="CancelNotInfoRequest()">Not An Info Request</button>
        </div>
    </form>
</div>
